<template>
    <common-modal
        v-if="isOpen && selectedReferral"
        width="small"
        :heading="$t('modals.patient.medical.steps.contect')"
        @close="$emit('close')"
    >
        <div class="contact-provider-modal">
            <div class="provider-info-card">
                <common-user-avatar :user="selectedReferral.fromUser" size="user-menu"></common-user-avatar>
                <div class="provider-details">
                    <h3 class="provider-name">{{ getProviderFullName(selectedReferral.fromUser) }}</h3>
                    <p v-if="selectedReferral.fromUser?.specialities?.length" class="provider-speciality">
                        {{ getStepSpeciality(selectedReferral.fromUser) }}
                    </p>
                    <p v-if="selectedReferral.fromPractice?.name" class="provider-practice">
                        {{ selectedReferral.fromPractice.name }}
                    </p>
                </div>
            </div>

            <div class="contact-actions-list">
                <div class="contact-action-item">
                    <div class="contact-meta">
                        <common-icon name="sms" size="semi-small"></common-icon>
                        <div class="contact-text">
                            <span class="contact-label">{{ $t('modals.patient.medical.contact_modal.email') }}</span>
                            <span class="contact-value">
                                {{ selectedReferral.fromUser?.email || $t('modals.patient.medical.contact_modal.na') }}
                            </span>
                        </div>
                    </div>
                    <a
                        v-if="selectedReferral.fromUser?.email"
                        :href="'mailto:' + selectedReferral.fromUser.email"
                        class="contact-action-btn email-btn"
                    >
                        <common-icon name="sms" size="tiny"></common-icon>
                        <span>{{ $t('modals.patient.medical.contact_modal.send_email') }}</span>
                    </a>
                </div>

                <div class="contact-action-item">
                    <div class="contact-meta">
                        <common-icon name="call" size="semi-small"></common-icon>
                        <div class="contact-text">
                            <span class="contact-label">{{ $t('modals.patient.medical.contact_modal.phone') }}</span>
                            <span class="contact-value">
                                {{ selectedReferral.fromUser?.phone || $t('modals.patient.medical.contact_modal.na') }}
                            </span>
                        </div>
                    </div>
                    <a
                        v-if="selectedReferral.fromUser?.phone"
                        :href="'tel:' + selectedReferral.fromUser.phone"
                        class="contact-action-btn phone-btn"
                    >
                        <common-icon name="call" size="tiny"></common-icon>
                        <span>{{ $t('modals.patient.medical.contact_modal.call_phone') }}</span>
                    </a>
                </div>
            </div>
        </div>
    </common-modal>
</template>

<script>
    export default {
        props: {
            isOpen: { type: Boolean, default: false },
            selectedReferral: { type: Object, default: null },
        },
        methods: {
            getStepSpeciality(user) {
                if (!user || !user.specialities || user.specialities.length === 0) return ''
                return user.specialities[0]?.speciality?.name || ''
            },
            getProviderFullName(user) {
                if (!user) return this.$t('modals.patient.medical.contact_modal.default_provider')
                const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ')
                const designation = user.designation || ''
                return (
                    [fullName, designation].filter(Boolean).join(', ') ||
                    this.$t('modals.patient.medical.contact_modal.default_provider')
                )
            },
        },
    }
</script>

<style scoped lang="scss">
    .contact-provider-modal {
        padding: 4px 0;
    }
    .provider-info-card {
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 12px;
        background: #f8fafc;
        border-radius: 10px;
        margin-bottom: 16px;
        border: 1px solid #e2e8f0;
    }
    .provider-details {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }
    .provider-name {
        font-size: 15px;
        font-weight: 600;
        color: #0f172a;
    }
    .provider-speciality {
        font-size: 13px;
        color: #2563eb;
        font-weight: 500;
    }
    .provider-practice {
        font-size: 12px;
        color: #64748b;
    }
    .contact-actions-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    .contact-action-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 14px;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        background: #ffffff;
    }
    .contact-meta {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .contact-text {
        display: flex;
        flex-direction: column;
    }
    .contact-label {
        font-size: 11px;
        text-transform: uppercase;
        color: #6b7280;
        font-weight: 600;
    }
    .contact-value {
        font-size: 13px;
        color: #111827;
        font-weight: 500;
    }
    .contact-action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 500;
        text-decoration: none;
        transition: background-color 0.15s ease;

        &.email-btn {
            background-color: #eff6ff;
            color: #2563eb;
            border: 1px solid #bfdbfe;
            &:hover {
                background-color: #dbeafe;
            }
        }
        &.phone-btn {
            background-color: #f0fdf4;
            color: #16a34a;
            border: 1px solid #bbf7d0;
            &:hover {
                background-color: #dcfce7;
            }
        }
    }
</style>
